import React from 'react';

import {
  Text,
} from 'react-native';

import * as BoxC from './_ccbBoxC';
import { a } from './_cmABT';
import * as _cr from './_cr';
import * as _hm from './_hm';
import * as _ht from './_ht';

export type tTextCz = {
  abtz?: _ht.dz,
  text?: _ht.s,
  textStlz?: _ht.dz,
  textPtyz?: _ht.dz,
  boxStlz?: _ht.dz,
  pslStlz?: _ht.dz,
  pslPtyz?: _ht.dz,
};

const $grtAbtz = (pz?: { 
  type?: _ht.s,
  tc?: _ht.s,
  ts?: _ht.s,
  tn?: _ht.n,
}) => {
  const _tc = pz?.tc ?? 'lt9';
  const _ts = pz?.ts ?? 'm';
  const _tn = pz?.tn ?? 'n';
  switch (pz?.type) {
    case 'lbl':
      return {
        textStlz: a(`tb tc/${_tc} tf/system ts/${_ts}`),
        textPtyz: {},
        boxStlz: {},
        pslStlz: {},
        pslPtyz: {}
      }
    default:
      return {
        textStlz: a(`tc/${_tc} tf/system ts/${_ts}`),
        textPtyz: a(`tn/${_tn}`),
        boxStlz: {},
        pslStlz: {},
        pslPtyz: {}
      }
  }
};

export const N = React.memo((pz: tTextCz) => {

  const _abtz = $grtAbtz(pz.abtz);
  const _text = pz.text;

  //_hm.l(`TextC 58: ${_hm.s(_text)}, ${_hm.s(_abtz)}`)
  let _o = (
    _cr.c(Text, {
//      accessible: false,
      selectable: false,
      ... _abtz?.textPtyz,
      ... pz.textPtyz,
      style: {
        ... _abtz.textStlz,
        ... pz.textStlz,
      },
    },
      _text
    )
  );

  if ( _hm.f(pz.boxStlz) || _hm.f(pz.pslPtyz) ) {
    _o = (
      _cr.c(BoxC.N, { // 改行されない場合、 stlz において dw/f を設定要
        boxStlz: {
          ... _abtz.boxStlz,
          ... pz.boxStlz,
        },
        pslStlz: {
          ... _abtz.pslStlz,
          ... pz.pslStlz,
        },
        pslPtyz: {
          ... _abtz.pslPtyz,
          ... pz.pslPtyz,
        },
        boxClds: _o
      })
    );
  }

  return _o;

});

/*
export const B = React.memo((pz: tTextCz) => {
  const _abtz = $grtAbtz(pz.textAbtz)
  return (
    _cr.c(BoxC.N, { // 改行されない場合、 stlz において dw/f を設定要
      boxStlz: {
        ... _abtz.boxStlz,
        ... pz.boxStlz,
      },
      boxPslz: {
      },
      boxClds: [
        _cr.c(N, {
          text: pz.text,
          textStlz: {
            ... _abtz.textStlz,
            ... pz.textStlz,
          },
          textPtyz: {
            ... _abtz.textPtyz,
            ... pz.textPtyz,
          },
        })
      ]
    })
  )
});
*/
